import cn from 'classnames';
import * as React from 'react';

import s from './CellWrapper.module.scss';

/** Фабрика для создания ячеек для хедера или тела таблицы */
const createCellFactory =
  (cell: 'th' | 'td') =>
  ({ className, children, ...tableProps }) => {
    const Element = cell;
    const isHeader = cell === 'th';

    return (
      <Element
        className={cn(s['cell-wrapper'], isHeader && s['cell-wrapper_header'], className)}
        {...tableProps}
      >
        {children}
      </Element>
    );
  };

/* Враппер для ячейки хедера (чтобы задать максимальную/минимальную ширину)*/
const HeaderCellWrapper = createCellFactory('th');

/* Враппер для ячейки тела (чтобы задать максимальную/минимальную ширину)*/
const BodyCellWrapper = createCellFactory('td');

export { HeaderCellWrapper, BodyCellWrapper };
